import React from 'react';
import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import { Bold, Italic, Underline as UIcon, List, ListOrdered, Heading2, Link as LinkIcon, Quote } from 'lucide-react';
import './richtext.css';

export const RichTextEditor = ({ value = '', onChange, placeholder = 'Rédigez votre contenu…' }) => {
  const editor = useEditor({
    extensions: [
      StarterKit.configure({
        link: { openOnClick: false, autolink: true },
      }),
    ],
    content: value,
    onUpdate: ({ editor }) => onChange && onChange(editor.getHTML()),
  });

  if (!editor) return null;

  const btnCls = (active) => `p-2 rounded transition-colors ${active ? 'bg-primary/15 text-primary' : 'text-muted-foreground hover:bg-primary/10'}`;

  const setLink = () => {
    const url = window.prompt('URL du lien (laisser vide pour retirer)');
    if (url === null) return;
    if (url === '') editor.chain().focus().unsetLink().run();
    else editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run();
  };

  return (
    <div className="border border-border rounded-md bg-background" data-testid="rich-text-editor">
      <div className="flex flex-wrap gap-1 border-b border-border p-1">
        <button type="button" title="Gras" data-testid="rte-bold" onClick={() => editor.chain().focus().toggleBold().run()} className={btnCls(editor.isActive('bold'))}><Bold size={16} /></button>
        <button type="button" title="Italique" data-testid="rte-italic" onClick={() => editor.chain().focus().toggleItalic().run()} className={btnCls(editor.isActive('italic'))}><Italic size={16} /></button>
        <button type="button" title="Souligné" data-testid="rte-underline" onClick={() => editor.chain().focus().toggleUnderline().run()} className={btnCls(editor.isActive('underline'))}><UIcon size={16} /></button>
        <button type="button" title="Titre" data-testid="rte-heading" onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()} className={btnCls(editor.isActive('heading', { level: 2 }))}><Heading2 size={16} /></button>
        <button type="button" title="Liste à puces" data-testid="rte-bullet" onClick={() => editor.chain().focus().toggleBulletList().run()} className={btnCls(editor.isActive('bulletList'))}><List size={16} /></button>
        <button type="button" title="Liste numérotée" data-testid="rte-ordered" onClick={() => editor.chain().focus().toggleOrderedList().run()} className={btnCls(editor.isActive('orderedList'))}><ListOrdered size={16} /></button>
        <button type="button" title="Citation" data-testid="rte-quote" onClick={() => editor.chain().focus().toggleBlockquote().run()} className={btnCls(editor.isActive('blockquote'))}><Quote size={16} /></button>
        <button type="button" title="Lien" data-testid="rte-link" onClick={setLink} className={btnCls(editor.isActive('link'))}><LinkIcon size={16} /></button>
      </div>
      <EditorContent editor={editor} className="rte-content max-w-none p-3 min-h-[180px]" />
    </div>
  );
};

export default RichTextEditor;
